import { isImmutable } from "immutable";
import { isArray,isNil } from "lodash";

export default ids => (isNil(ids) ? [] : isImmutable(ids) ? ids.toArray() : isArray(ids) ? ids : [ids]);
